import { render, staticRenderFns } from "./ECerts.vue?vue&type=template&id=84e41294&scoped=true&"
import script from "./ECerts.vue?vue&type=script&lang=js&"
export * from "./ECerts.vue?vue&type=script&lang=js&"
import style0 from "./ECerts.vue?vue&type=style&index=0&id=84e41294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e41294",
  null
  
)

export default component.exports